import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import PageHeader from '../../../shared/page-header/components/page-header';
import CloseBtn from '../../../shared/close-btn/components/close-btn';
import Button from '../../../shared/button/components/button';
import { toggleMobileCampaignModal, requestInstallLink } from '../actions/campaigns-actions';

class MobileCampaignModal extends Component {
  closeModal() {
    const { toggleMobileCampaignModal } = this.props;

    toggleMobileCampaignModal(false);
  }

  requestMobileLink() {
    const { profile, requestInstallLink } = this.props;

    requestInstallLink(profile.user_name, profile.email);
  }

  render() {
    const { showMobileCampaignModal, createCampaignInProgress } = this.props;
    const { t } = this.context;

    return (
      <Modal visible={showMobileCampaignModal} effect="fadeInUp" onClickAway={() => this.closeModal()}>
        <div className="default-modal">
          <CloseBtn callback={this.closeModal.bind(this)} />
          <div className="text-center">
            <PageHeader title={'CAMPAIGNS.CREATE_NEW'} />
          </div>
          <div className="text-center">
            <span className="glyphicon glyphicon-info-sign font-size-24" />
            <p>{t('CAMPAIGNS.MOBILE_CAMPAIGN_MESSAGE')}</p>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <Button label={'CAMPAIGNS.REQUEST_MOBILE_LINK'} disabled={createCampaignInProgress} customClass={`affiliate-btn-red m-t-20`} onClick={() => this.requestMobileLink()} />
            </div>
            <div className="col-sm-12">
              <Button label={'COMMON.CLOSE'} customClass={`m-t-10`} onClick={() => this.closeModal()} />
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  showMobileCampaignModal: state.campaignsReducer.showMobileCampaignModal,
  createCampaignInProgress: state.campaignsReducer.createCampaignInProgress,
  profile: state.userProfileReducer.profile,
});

const mapDispatchToProps = dispatch => ({
  toggleMobileCampaignModal: show => {
    dispatch(toggleMobileCampaignModal(show));
  },
  requestInstallLink: (username, email) => {
    dispatch(requestInstallLink(username, email));
  },
});

MobileCampaignModal.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileCampaignModal);



// WEBPACK FOOTER //
// ./src/app/main/campaigns/components/mobile-campaign-modal.js